import { render, staticRenderFns } from "./DataHeader.vue?vue&type=template&id=a8e53a0e&scoped=true"
import script from "./DataHeader.vue?vue&type=script&lang=js"
export * from "./DataHeader.vue?vue&type=script&lang=js"
import style0 from "./DataHeader.vue?vue&type=style&index=0&id=a8e53a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e53a0e",
  null
  
)

export default component.exports